import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuth } from './hooks/useAuth';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { TelegramSettingsPage } from './pages/TelegramSettingsPage';
import { RequestsPage } from './pages/RequestsPage';
import { ChatsPage } from './pages/ChatsPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { EmailsPage } from './pages/EmailsPage';
import { LoginPage } from './pages/LoginPage';
import { AdminLayout } from './components/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';

// OIDC redirect landing. Keycloak sends the browser back to /redirect_uri;
// react-oidc-context exchanges the code while this renders. The subsequent
// <Navigate> is a real router navigation — onSigninCallback's
// history.replaceState alone is invisible to React Router, which is what
// used to leave the app blank until a manual refresh.
const AuthCallback: React.FC = () => {
  const { isLoading } = useAuth();
  if (isLoading) {
    return <div className="min-h-screen" style={{ background: '#FBFBFC' }} aria-busy="true" />;
  }
  return <Navigate to="/" replace />;
};

function App() {
  return (
    <>
      <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/redirect_uri" element={<AuthCallback />} />
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/chats" element={<ChatsPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
      </Route>
      <Route
        path="/"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:id" element={<UserDetailPage />} />
        <Route path="emails" element={<EmailsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/telegram" element={<TelegramSettingsPage />} />
      </Route>
      </Routes>
      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          classNames: {
            toast:
              'group toast group-[.toaster]:bg-white group-[.toaster]:text-slate-900 group-[.toaster]:border group-[.toaster]:border-slate-200 group-[.toaster]:shadow-lg',
            description: 'group-[.toast]:text-slate-600',
            actionButton: 'group-[.toast]:bg-slate-900 group-[.toast]:text-white',
            cancelButton: 'group-[.toast]:bg-slate-100 group-[.toast]:text-slate-600',
          },
        }}
      />
    </>
  );
}

export default App;
